export default __webpack_public_path__ + "static/media/totalWithdrawalsIcon.9dda2e3d.svg";